import React, { useMemo } from "react";
import ImageGallery from "react-image-gallery";
import { Box } from "@mui/material";
import "react-image-gallery/styles/css/image-gallery.css";
import "./HouseGallery.css";
import { tokens } from "../../../../store/tokens";

function HouseGallery({ fetchedServicePic }) {
  // `fetchedServicePic.map(...)` with no guard would throw if this ever
  // rendered before the fetch resolved or with a malformed response —
  // this only ever gets called when the parent has already checked
  // `length > 1`, but that's an easy invariant to break later, so it's
  // worth being defensive here too.
  const pictures = useMemo(
    () =>
      (Array.isArray(fetchedServicePic) ? fetchedServicePic : [])
        .filter((element) => element?.mpic)
        .map((element, index) => ({
          original: element.mpic,
          thumbnail: element.mpic,
          originalAlt: `Service photo ${index + 1}`,
          thumbnailAlt: `Service photo ${index + 1} thumbnail`,
        })),
    [fetchedServicePic]
  );

  if (pictures.length === 0) return null;

  return (
    <Box
      sx={{
        borderRadius: `${tokens.radius.md}px`,
        overflow: "hidden",
        boxShadow: tokens.shadow.sm,
        "& .image-gallery-thumbnail.active, & .image-gallery-thumbnail:hover": {
          border: `2px solid ${tokens.color.teal}`,
        },
        "& .image-gallery-icon:hover": {
          color: tokens.color.teal,
        },
      }}
    >
      <ImageGallery items={pictures} showPlayButton={false} showFullscreenButton lazyLoad />
    </Box>
  );
}

export default HouseGallery;